import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';

import { Observable, throwError } from 'rxjs';
import { Retention } from '../_models';
import { ArrayResponse, BaseResponse } from '../_common';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RetentionService {

  constructor(private http: HttpClient) { }

  getAll(filter: any, realtimeFlag: boolean): Observable<any>  { //listing
    return this.http.post(`${environment.apiUrl}/report/retention/graph?realtime=${realtimeFlag}`, filter)
    .pipe(
      map((data: any) => {
        if(data.status !== 1 || (data.status == 1 && !data.data)){
          return {status: null, msg: data.msg};
        }else{
          return new ArrayResponse().deserialize(data, Retention);
        }
      }),
      catchError(error => throwError(error.message || error))
    );
  }

  export(filter: any, realtimeFlag: boolean): Observable<any> { //export
    return this.http.post(`${environment.apiUrl}/report/retention/export?realtime=${realtimeFlag}`, filter);
  }
}
